import BaseViewModel from '@src/slide/infrastructure/module/independent/view-service-define/base/base-view-model';
import { IRightSideBarProps, IRightSideBarState } from './interface';

export default class RightSideBarModel extends BaseViewModel<IRightSideBarProps>
    implements IRightSideBarState {
    public visible: boolean;
    public width: number;

    public initModel(props: IRightSideBarProps, initObj?: Partial<this>): void {
        this.visible = false;
        this.width = 280;
    }
}
